module.exports = __webpack_public_path__ + "static/media/step-4-reviews.1f01ee3e.webp";